import { Tooltip } from '@skytech/ui'
import { NameAvatar } from '@skytech/ui/NameAvatar'
import { Td } from '@skytech/ui/Table/Td'
import CommentIcon from 'mdi-react/CommentOutlineIcon'

import { Translation } from '@/app/translations/Translation'
import { useTranslation } from '@/app/translations/translations-hooks'
import Highlight from '@/components/Highlight'
import { LocalDate } from '@/components/LocalDate'
import { TrLink } from '@/components/TrLink'

import { SUB_SERVICE_ORDER_STATUS_BY_ID } from '../constants'

import type { Subscription } from './types'

import './SubscriptionListItem.styles.scss'

const NewSubscriptionListItem = ({
  id,
  employeeNumber,
  nameNew,
  phoneNo,
  activationDate,
  orgNo,
  customerName,
  created,
  updated,
  searchFilter,
  status,
  comment,
}: Subscription & { searchFilter: string }) => {
  const translate = useTranslation()
  const rowTooltipId = `row-tooltip-${id}`

  return (
    <TrLink data-tooltip-id={rowTooltipId} path={String(id)} className="new-subscription-list-item">
      <Td>
        <NameAvatar name={nameNew} />
      </Td>
      <Td>
        <div className="user-name">
          <Highlight pattern={searchFilter} text={nameNew} />
        </div>

        {employeeNumber && (
          <div className="employee-no">
            <Highlight pattern={searchFilter} text={employeeNumber} />
          </div>
        )}
      </Td>

      <Td>{Boolean(phoneNo) && <Highlight pattern={searchFilter} text={String(phoneNo)} />}</Td>
      <Td className="company-name">
        <div className="company-name">
          <Highlight pattern={searchFilter} text={customerName} />
        </div>

        <div className="company-number">
          <Highlight pattern={searchFilter} text={orgNo} />
        </div>
      </Td>

      <Td className="mobile-view">
        <div>
          <div className="user-name">
            <Highlight pattern={searchFilter} text={nameNew} />
          </div>

          {phoneNo && (
            <div className="phone-no">
              <Highlight pattern={searchFilter} text={phoneNo} />
            </div>
          )}
        </div>

        <div>
          <div className="status">
            <Highlight
              pattern={searchFilter}
              text={translate(`sub_service_order_status/${SUB_SERVICE_ORDER_STATUS_BY_ID[status]}`)}
            />
            {comment && <CommentIcon className="ml-2 w-4" />}
          </div>

          <div className="activation-date">
            <LocalDate date={activationDate} />
          </div>
        </div>
      </Td>

      <Td>
        <Highlight
          pattern={searchFilter}
          text={translate(`sub_service_order_status/${SUB_SERVICE_ORDER_STATUS_BY_ID[status]}`)}
        />
        {comment && <CommentIcon className="ml-2 w-4" />}
      </Td>

      <Td>
        <LocalDate date={activationDate} />
      </Td>

      <Td>
        <LocalDate date={created} />
      </Td>
      <Td>
        <LocalDate date={updated} />
      </Td>

      {comment && (
        <Tooltip
          id={rowTooltipId}
          size="large"
          float
          noArrow
          variant="light"
          place="bottom-start"
          opacity={1}
          // TODO: REMOVE the '!important' when the tooltip is refactored to use tw
          className="!rounded-lg !py-2.5 shadow-md"
        >
          <div className="text-left">
            <div className="mb-1 text-sm text-gray-400">
              <Translation id="Order comment " />
            </div>
            <span>{comment}</span>
          </div>
        </Tooltip>
      )}
    </TrLink>
  )
}

export default NewSubscriptionListItem
